import axios from "axios";
let number = 0;

export const loadMore = (title = "", location = "", fulltime = false) => {
  return async (dispatch) => {
    number++;
    const response = await axios.get(
      "https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json",
      {
        params: {
          description: title,
          location,
          fulltime,
          page: number,
        },
      }
    );
    dispatch({
      type: "LOAD_MORE",
      payload: response.data,
    });
  };
};

export const fetchJobs = () => {
  return async (dispatch) => {
    const response = await axios.get(
      "https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json"
    );
    dispatch({
      type: "FETCH_JOBS",
      payload: response.data,
    });
  };
};

export const filterJobs = (title = "", location = "", fulltime = false) => {
  return async (dispatch) => {
    const response = await axios.get(
      "https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions.json",
      {
        params: {
          description: title,
          location,
          fulltime,
        },
      }
    );
    dispatch({ type: "FILTER_JOBS", payload: response.data });
  };
};

export const fetchJob = (id) => {
  return async (dispatch) => {
    const response = await axios.get(
      `https://cors-anywhere.herokuapp.com/https://jobs.github.com/positions/${id}.json`,
      {
        params: {
          markdown: true,
        },
      }
    );
    dispatch({ type: "FETCH_JOB", payload: response.data });
  };
};

export const addLoader = () => {
  return {
    type: "ADD_LOADER",
  };
};

export const removeLoader = () => {
  return {
    type: "REMOVE_LOADER",
  };
};

export const setDarkMode = () => {
  return {
    type: "SET_DARK_MODE",
  };
};

export const showMenu = () => {
  return {
    type: "SHOW_MENU",
  };
};
